import React from 'react';
import EmptyState from './EmptyState';
import ColumnHeaderControls from './ColumnHeaderControls';
import { resolveColumnFilter } from './columnFilters';

const SkeletonRows = ({ columns, rows = 5 }) => (
    <>
        {[...Array(rows)].map((_, i) => (
            <tr key={i} className="placeholder-glow">
                <td className='py-3 px-3'><span className="placeholder col-8 rounded"></span></td>
                {columns.map((_, j) => (
                    <td key={j} className="py-3 px-3">
                        <span className="placeholder col-10 rounded"></span>
                    </td>
                ))}
            </tr>
        ))}
    </>
);

const Table = ({
    columns = [], data = [], loading, isRefreshing = false, page = 0, pageSize = 10, onRowClick = false,
    emptyReason = "empty", onAddNew, addLabel, onClearSearch, onClearFilters,
    filterItems = {}, searchKeys = [], filters = {}, initialFilters = {}, onFilterChange,
}) => {
    const isInitialLoading = loading && !isRefreshing;
    const emptyAction = {
        empty: { actionLabel: addLabel, onAction: onAddNew },
        search: { actionLabel: onClearSearch ? "Clear search" : undefined, onAction: onClearSearch },
        filter: { actionLabel: onClearFilters ? "Clear filters" : undefined, onAction: onClearFilters },
    }[emptyReason] || {};

    return (
        <div className={`list-table-wrap ${isRefreshing ? "is-refreshing" : ""}`}>
            <div className='table-responsive list-table-scroll'>
                <table className='table table-hover align-middle mb-0 list-table'>
                    <thead className='sticky-top'>
                        <tr>
                            <th className="py-3 px-3 text-center list-th">S.No</th>
                            {columns.map((col) => {
                                const descriptor = resolveColumnFilter(col, { filterItems, searchKeys });
                                return (
                                    <th key={col.key} className={`py-3 px-3 list-th ${col.align ? `text-${col.align}` : ""}`}>
                                        {onFilterChange ? (
                                            <ColumnHeaderControls
                                                column={col}
                                                descriptor={descriptor}
                                                filters={filters}
                                                initialFilters={initialFilters}
                                                onFilterChange={onFilterChange}
                                            />
                                        ) : col.name}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {isInitialLoading ? (
                            <SkeletonRows columns={columns} rows={5} />
                        ) : data.length !== 0 ? (
                            data.map((item, idx) => (
                                <tr
                                    key={item.id || item._id || idx}
                                    className={onRowClick ? 'cursor-pointer' : ''}
                                    onClick={() => { if (onRowClick) onRowClick?.(item) }}
                                >
                                    <td className='px-3 text-center text-muted small'>{(((page || 1) - 1) * pageSize) + (idx + 1)}</td>
                                    {columns.map((col) => (
                                        <td key={col.key} className={`px-3 ${col.align ? `text-${col.align}` : ""}`}>
                                            {col.render ? col.render(item) : (item[col.key] ?? "-")}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns?.length + 1} className="border-0">
                                    <EmptyState reason={emptyReason} actionLabel={emptyAction.actionLabel} onAction={emptyAction.onAction} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {isRefreshing ? <div className="list-refresh-bar" aria-hidden="true" /> : ""}
        </div>
    );
};

export default Table;
